"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = exports.CSS = exports.MDL = void 0;
const theme_1 = require("../../components/theme");
const theme_palette_1 = require("../../components/theme.palette");
const dashboard_table_style_1 = require("./dashboard.table.style");
//these colours are on the advice of marketing team.
const orangeFull = 'rgba(255, 131, 0, 1)';
//const orangeTrans = 'rgba(255, 131, 0, .1)';
const redFull = 'rgba(224, 69, 4, 1)';
//const redTrans = 'rgba(224, 69, 4, .1)';
//const yellowFull = 'rgba(255, 198, 41, 1)';
//const yellowTrans = 'rgba(255, 198, 41, .1)';
const greyFull = 'rgba(208, 207, 205, 1)';
const greyTrans = 'rgba(208, 207, 205, .25)';
exports.MDL = {
    button: 'mdl-button',
    title: 'mdl-layout-title',
    spacer: 'mdl-layout-spacer',
    drawer: {
        button: 'mdl-layout__drawer-button'
    }
};
exports.CSS = {
    container: 'c-Dashboard',
    title: 'c-Dashboard__title',
    message: 'c-Dashboard__message',
    tableCell: 'c-Dashboard__TableCell',
    tableCellFaint: 'c-Dashboard__TableCell--faint',
    tableCellGhost: 'c-Dashboard__TableCell--ghost',
    tableCellRoleActions: 'c-Dashboard__TableCellRole'
};
exports.Banner = {
    header: {
        container: 'c-Dash-Header',
        row: 'c-Dash-Header_row',
        section: 'c-Dash-Header__section'
    },
    menuButton: {
        span: 'c-Dash-Span',
        spanSelected: 'c-Dash-Span__selected'
    }
};
(0, theme_1.addStyles)({
    [dashboard_table_style_1.CSS.header]: {
        ['& .mdl-data-table__cell--non-numeric']: {
            'white-space': 'normal'
        }
    },
    [exports.CSS.container]: {
        width: '95%',
        margin: 'auto',
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
        'padding-bottom': '5px',
        [`& .${dashboard_table_style_1.CSS.container}`]: {
            border: 0,
            'table-layout': 'fixed',
            '& th': {
                position: 'sticky',
                top: '0',
                'z-index': '10',
                color: 'black'
            },
            ['& thead']: {
                ['& th']: {
                    width: '100%',
                    'background-color': greyFull
                },
                ['& .execHeader1']: {
                    'background-color': redFull,
                    width: '100%'
                },
                ['& .execHeader0']: {
                    'background-color': orangeFull,
                    width: '100%'
                },
                '& td:first-of-type, & th:first-of-type': {
                    width: 'min-content',
                    'min-width': 'min-content',
                    'background-color': greyFull
                },
                '& td:nth-of-type(2), & th:nth-of-type(2)': {
                    width: '250px',
                    'white-space': 'normal',
                    'background-color': greyFull
                }
            },
            '& td': {},
            '& td:first-of-type, & th:first-of-type': {
                width: 'min-content',
                'min-width': 'min-content'
            },
            '& td:nth-of-type(2), & th:nth-of-type(2)': {
                width: '250px',
                'white-space': 'normal'
            },
            ['& .execHeader1']: {
                'background-color': greyTrans,
                '& span': {
                    'background-color': 'rgba(0,0,0,0)'
                }
            },
            ['& .execHeader0']: {
                '& span': {
                    'background-color': 'rgba(0,0,0,0)'
                }
            }
        }
    },
    [exports.CSS.title]: {
        padding: '0 ' + theme_1.DefaultTheme.space(6),
        height: theme_1.DefaultTheme.space(12),
        'line-height': theme_1.DefaultTheme.space(12),
        display: 'flex',
        '& h6': {
            margin: 0,
            'line-height': theme_1.DefaultTheme.space(12)
        }
    },
    [exports.CSS.message]: {
        padding: theme_1.DefaultTheme.space(6)
    },
    [exports.CSS.tableCellFaint]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [`${dashboard_table_style_1.CSS.row}:hover .${exports.CSS.tableCellGhost}`]: {
        visibility: 'visible'
    },
    [exports.CSS.tableCellGhost]: {
        visibility: 'hidden'
    },
    [exports.CSS.tableCellRoleActions]: {
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
        width: '100%'
    },
    [exports.Banner.menuButton.span]: {
        margin: `0 ${theme_1.DefaultTheme.space(2)}`,
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    [exports.Banner.menuButton.spanSelected]: {
        margin: `0 ${theme_1.DefaultTheme.space(2)}`,
        color: `rgb(${theme_palette_1.ColorPaletteOrange.C300})`,
        'font-weight': theme_1.DefaultTheme.font.weight.normal,
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis'
    },
    [exports.Banner.header.container]: {
        height: theme_1.DefaultTheme.space(10),
        'min-height': theme_1.DefaultTheme.space(10),
        width: '100%'
    },
    [exports.Banner.header.row]: {
        display: 'flex',
        'flex-direction': 'row',
        'align-items': 'center',
        height: theme_1.DefaultTheme.space(10),
        'padding-left': theme_1.DefaultTheme.space(14),
        'padding-right': theme_1.DefaultTheme.space(2),
        'min-height': theme_1.DefaultTheme.space(10),
        color: `rgb(${theme_palette_1.WHITE})`,
        [`& .${exports.MDL.title}`]: {
            'white-space': 'nowrap',
            'margin-right': theme_1.DefaultTheme.space(2)
        },
        '& i': {}
    },
    [exports.Banner.header.section]: {
        display: 'flex',
        flex: 1,
        'align-items': 'center'
    }
});
//# sourceMappingURL=dashboard.style.js.map